import * as types from '../actions/actionTypes';
import initialState from './initialState';


export default function makeOrderList(state = initialState.makeOrders, action) {

    switch (action.type) {
        case types.ADD_BID_USER:

            return Object.assign({}, state, {
                dataBidUser: { results: [...state.dataBidUser.results, action.bid_user] }
            })

        case types.SORT_BID_USER:
            // Сортирует список откликнувшихся юзеров по дате отклика.
            const ListBidUser = [...state.dataBidUser.results];

            ListBidUser.sort(function (a, b) {
                return new Date(a.created_at) - new Date(b.created_at);
            });

            return Object.assign({}, state, {
                dataBidUser: { results: [...ListBidUser] }
            })

        case types.ADD_BID_MESSAGES_USERS:

            const dataBidUser = state.dataBidUser.results.map((item, index) => {
                if (item.bid_id !== action.bid_id) {
                    return item;
                }

                return {
                    ...item,
                    messages_count: action.countMessages,
                    nextPage: action.nextPage,
                    messages_users: action.bid_users_messages.reverse()
                };
            });

            return Object.assign({}, state, {
                dataBidUser: { results: [...dataBidUser] }
            })

        case types.CLEAR_BID_USER:
            return Object.assign({}, state, {
                dataBidUser: { results: [] }
            })

        case types.RESET_ALL_INFO:
            return initialState.makeOrders

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/makeOrderReducer.js